<template>
  <div>
    <MemberLayout activeLink="news">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <h3>您目前累積點數共有</h3>
                <h3>
                  <span class="text-warning point-show">0</span>

                  點
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MemberLayout>
  </div>
</template>
<script>
import MemberLayout from "../../components/member/MemberLayout";
import { getCurrentJPNSEQ } from "../../api/fordaysHelpers";
export default {
  name: "PointCardScreen",
  components: {
    MemberLayout,
  },
  data() {
    return {
      points: 0,
    };
  },
  mounted() {
    const vm = this;
    const JPNSEQ = getCurrentJPNSEQ();
    // const pointAPIURL = `http://118.163.31.143:5050/api/JBonusPoint_MasterOut/?jpnseq=${JPNSEQ}`;
    const pointAPIURL = `${vm.$hostURL}/member/point-card`;
    vm.axios
      .post(pointAPIURL, { JPNSEQ })
      .then((res) => {
        const points = res.data.points;
        vm.points = points;
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>
<style lang="scss" scoped>
.point-show {
  font-size: 72px;
}
</style>